/**
 * Default pagination values
 */
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Column meta type for DataTable compatibility
 */
export interface ConversationColumnMeta {
  label: string;
  variant?: "text" | "date" | "badge" | "status";
  headerClassName?: string;
}
